export default __webpack_public_path__ + "static/media/Initiate's Armbands of the Forbidden Art.0c52b6cc.jpg";